module.exports = __webpack_public_path__ + "static/media/news.93498d70.png";